/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GenericResponse,
} from '../models/index';
import {
    GenericResponseFromJSON,
    GenericResponseToJSON,
} from '../models/index';

export interface SaveRequest {
    body: any;
}

export interface UpdateRequest {
    body: any;
}

/**
 * 
 */
export class CommandApi extends runtime.BaseAPI {

    /**
     * A generic DELETE command. You cannot invoke this method.
     * Generic DELETE method, (DELETE)
     */
    async _deleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/__COMMANDS__/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericResponseFromJSON(jsonValue));
    }

    /**
     * A generic DELETE command. You cannot invoke this method.
     * Generic DELETE method, (DELETE)
     */
    async _delete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericResponse> {
        const response = await this._deleteRaw(initOverrides);
        return await response.value();
    }

    /**
     * A generic DUMMY command. You cannot invoke this method.
     * Dummy method for including types into model
     */
    async dummyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/__COMMANDS__/dummy`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A generic DUMMY command. You cannot invoke this method.
     * Dummy method for including types into model
     */
    async dummy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dummyRaw(initOverrides);
    }

    /**
     * A generic GET command. You cannot invoke this method.
     * Generic GET method, (READ)
     */
    async getRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/__COMMANDS__/get`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericResponseFromJSON(jsonValue));
    }

    /**
     * A generic GET command. You cannot invoke this method.
     * Generic GET method, (READ)
     */
    async get(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericResponse> {
        const response = await this.getRaw(initOverrides);
        return await response.value();
    }

    /**
     * A generic POST command. You cannot invoke this method.
     * Generic POST method, (CREATE)
     */
    async saveRaw(requestParameters: SaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericResponse>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling save.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/__COMMANDS__/post`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericResponseFromJSON(jsonValue));
    }

    /**
     * A generic POST command. You cannot invoke this method.
     * Generic POST method, (CREATE)
     */
    async save(requestParameters: SaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericResponse> {
        const response = await this.saveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A generic PUT command. You cannot invoke this method.
     * Generic PUT method, (UPDATE)
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericResponse>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling update.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/__COMMANDS__/put`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericResponseFromJSON(jsonValue));
    }

    /**
     * A generic PUT command. You cannot invoke this method.
     * Generic PUT method, (UPDATE)
     */
    async update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericResponse> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
